import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoMastercard24 = t0 => {
  const $ = _c(7);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M14.7045 7.48779H9.29639V17.2063H14.7045V7.48779Z" fill="#FF5F00" />;
    t2 = <path d="M9.63947 12.3473C9.63862 11.4114 9.85072 10.4875 10.2597 9.64563C10.6687 8.80376 11.2638 8.06597 12.0001 7.48811C11.0884 6.77144 9.99334 6.32575 8.84024 6.20199C7.68714 6.07822 6.52249 6.28138 5.47939 6.78824C4.4363 7.2951 3.55685 8.0852 2.94157 9.06825C2.32629 10.0513 2 11.1876 2 12.3473C2 13.5071 2.32629 14.6434 2.94157 15.6264C3.55685 16.6095 4.4363 17.3996 5.47939 17.9064C6.52249 18.4133 7.68714 18.6165 8.84024 18.4927C9.99334 18.3689 11.0884 17.9232 12.0001 17.2066C11.2639 16.6287 10.6687 15.8909 10.2597 15.0491C9.85072 14.2072 9.63862 13.2833 9.63947 12.3473Z" fill="#EB001B" />;
    t3 = <path d="M21.9998 12.3473C21.9999 13.507 21.6736 14.6434 21.0584 15.6264C20.4431 16.6095 19.5637 17.3996 18.5206 17.9064C17.4775 18.4133 16.3129 18.6165 15.1598 18.4927C14.0067 18.3689 12.9117 17.9232 12 17.2066C12.7356 16.6281 13.3303 15.8902 13.7392 15.0485C14.1482 14.2067 14.3606 13.2831 14.3606 12.3473C14.3606 11.4115 14.1482 10.4879 13.7392 9.6462C13.3303 8.80446 12.7356 8.06655 12 7.48811C12.9117 6.77144 14.0067 6.32575 15.1598 6.20198C16.3129 6.07822 17.4775 6.28139 18.5206 6.78825C19.5637 7.29511 20.4431 8.08522 21.0584 9.06827C21.6736 10.0513 21.9999 11.1876 21.9998 12.3473Z" fill="#F79E1B" />;
    t4 = <path d="M21.4102 16.177V15.9781H21.4905V15.9375H21.2861V15.9781H21.3664V16.177H21.4102ZM21.8069 16.177V15.9371H21.7443L21.6722 16.1021L21.6002 15.9371H21.5375V16.177H21.5817V15.9961L21.6493 16.1521H21.6952L21.7627 15.9957V16.177H21.8069Z" fill="#F79E1B" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== ariaLabel || $[5] !== className) {
    t5 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}{t3}{t4}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default IcoMastercard24;